var Preconditions = require('./Preconditions.js'); 


function Labels()
{
    this.data = new Map();
    this.data_endpoint_labels = new Map();
}


Labels.prototype.upsert = function(new_data)
{
    // Convenience method to handle an array of new labels...
    if ( Array.isArray(new_data) )
    {
        for ( var i = 0; i < new_data.length; i++ )
        {
            var label = new_data[i];

            this.upsert(label);
        }
        return;
    }

    // Upsert one label
    Preconditions.checkJson(new_data, 'endpoint: String', 'label: String');
    this.data.set(new_data.endpoint, new_data.label);
    this.data_endpoint_labels.set(new_data.endpoint, new_data.endpoint_label);
}

Labels.prototype.get = function(endpoint)
{
    Preconditions.checkString(endpoint);

    var label = this.data.get(endpoint);

    if ( label == null || label.trim().length == 0 ) 
    {
        label = endpoint;

        // prettyprint endpoint (for US phone numbers)...
        if ( endpoint.length == 17 && endpoint.startsWith("E164:+1") )
        {
            label = endpoint.substring("E164:+1".length);
            label = "("+label.substring(0,3)+") "+label.substring(3,6)+"-"+label.substring(6,10);
        }
    }



    return label;
}

Labels.prototype.getWithEndpointLabel = function(endpoint)
{
    let ret = this.get(endpoint);
    let endpoint_label = this.data_endpoint_labels.get(endpoint);

    if ( endpoint_label == null ) return ret;
    endpoint_label = endpoint_label.trim();
    if ( endpoint_label.length == 0 ) return ret;
    
    return ret+' ('+endpoint_label+')';
}

module.exports = Labels;